function validateCreateNewPasswordForm(){
    const formCreateNewPassword = document.querySelector('.js-create-new-password-form');
    const passwordInput = document.querySelector('.js-create-new-password-field');
    const passwordError = document.querySelector('.js-create-new-password-sign');

    let passwordDefaultState = true;
    
    $(passwordInput).on('blur', function(){
        if($(this).val() != '' && passwordDefaultState == true){
            passwordDefaultState = false;
            validatePassword(passwordInput, passwordError);
        }
    });

    $(formCreateNewPassword).submit(function(e) {
        e.preventDefault();
    
        if (validatePassword(passwordInput, passwordError)) {
            $(this).off('submit').on('submit', function(){
                return true
            });
            $(this)[0].submit();
        } else {
            console.log('Validation failed');
        }
    });
    
    passwordInput.addEventListener('input', () => {
        if(!passwordDefaultState){
            validatePassword(passwordInput, passwordError);
        }
    });
}

runIfElementExist(validateCreateNewPasswordForm, '.js-create-new-password-form');
